import React from 'react'
import glamorous from 'glamorous'
import PropTypes from 'prop-types'
import content from 'pp-react-l10n'

const i18n = content('transfer/24-hour-holds/index')

export const ButtonContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  margin: 'auto',
})

export const SendButton = glamorous.button('vx_btn', {
  margin: '1.5rem 0',
})

export const DontSendButton = glamorous.button('vx_btn-link')

export default function ActionButtons({ onConfirm, onCancel }) {
  return (
    <ButtonContainer>
      <SendButton data-nemo="risk-holds-send-button" onClick={onConfirm}>
        {i18n('button.send')}
      </SendButton>
      <DontSendButton
        data-nemo="risk-holds-dont-send-button"
        onClick={onCancel}
      >
        {i18n('button.dontSend')}
      </DontSendButton>
    </ButtonContainer>
  )
}

ActionButtons.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
